export { default } from './Alert';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Alert/index.jsx